import { AppLicense } from '@core/licenses';

export enum ApiErrorCode {
  InvalidTFACode = 'invalid_two_factor_code',
  InvalidRecoveryCode = 'invalid_recovery_code',
  TokenNotValid = 'token_not_valid',
  FlowDataInvalid = 'flow_data_invalid_error',
}

export interface EnvironmentApiConfig {
  apiHost: string;
  grpcHost?: string;
}

export type EnvironmentConfig = Record<AppLicense, EnvironmentApiConfig>;

export enum AppEnvironment {
  Dev = 'dev',
  Stage = 'stage',
  Prod = 'prod',
}
